var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdjustmentsVertical = function SvgAdjustmentsVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.75 3.75a.75.75 0 0 0-1.5 0v9.128a2.251 2.251 0 0 0 0 4.244v3.128a.75.75 0 0 0 1.5 0v-3.128a2.251 2.251 0 0 0 0-4.244zM5.25 15a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0M12.75 3.75a.75.75 0 0 0-1.5 0v3.128a2.25 2.25 0 0 0 0 4.244v9.128a.75.75 0 0 0 1.5 0v-9.128a2.251 2.251 0 0 0 0-4.244zM11.25 9a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0M18.75 3.75a.75.75 0 0 0-1.5 0v9.128a2.251 2.251 0 0 0 0 4.244v3.128a.75.75 0 0 0 1.5 0v-3.128a2.251 2.251 0 0 0 0-4.244zM17.25 15a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0",
    clipRule: "evenodd"
  })));
};
export default SvgAdjustmentsVertical;